import { useState, useEffect } from 'react';
import css from './CertificateOverview.module.css';

import * as certificateServices from '../../../../../services/certificateServices.js';

import ModalForm from '../../../_common/ModalForm';
// import AddNewCourse from './AddNewCourse';
import PlusButton from '../../../_common/elements/PlusButton';
import CertificateTable from './CertificateTable.js';
import AddNewCertificate from './AddNewCertificate.js';

function CertificateOverview() {
    const [certificates, setCertificates] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        certificateServices
            .getAll(page || 1)
            .then((result) => {
                setCertificates((state) => result.data.sort((a, b) => b.certificateId-a.certificateId) || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onAdd = (newData) => {
        // setCertificates((state) => [
        //     {
        //         ID: newData.courseNo,
        //         Title: newData.courseTitle,
        //         Type: '',
        //         Start: newData.courseStart,
        //         End: newData.courseEnd,
        //         Status: 'Acquisition',
        //     },
        //     ...state,
        // ]);
    };

    //Open and close the input form
    const toggleModal = () => setShowModal(!showModal);

    //Provides the start of the link for the details
    const detailsTo = '/certificate/details/';

    return (
        <div className={css.main}>
            <div>
                <CertificateTable data={certificates} detailsTo={detailsTo} />
            </div>
            <div>
                <div>
                    <PlusButton onClick={toggleModal} />
                    <ModalForm showModal={showModal}>
                        <AddNewCertificate data={certificates} onAdd={onAdd} toggleModal={toggleModal} />
                    </ModalForm>
                </div>
                <></>
            </div>
        </div>
    );
}

export default CertificateOverview;

